import BidderAlmost from "../../newComponents/bidDetails/bidderAlmost";
import PriceSkeleton from './priceSkeleton'
const BidDetailsPrice = (props) => {
    const { project_id,
        provider_project_id,
        project_number,
        bidDetailsLoading,
        from,
        hireData,
        history,
        bidDetails, } = props;
    const bodyProps = {
        bodyClasses: "ec-inbidding__body ec-profile__background"
    };
    return (
        <div>
            { !bidDetailsLoading ? 
                <>
                    {hireData && <BidderAlmost
                        the_project_id={project_id}
                        project_id={project_id}
                        provider_project_id={provider_project_id}
                        project_number={project_number}
                        {...hireData}
                        history={history}
                        from={from}
                    />
                    }
                </> 
                :
                <></>
            }
        </div>
    );
}

export default BidDetailsPrice;